export var InputType;
(function (InputType) {
    InputType[InputType["SELECT"] = 0] = "SELECT";
    InputType[InputType["CHECKBOX"] = 1] = "CHECKBOX";
    InputType[InputType["RADIO"] = 2] = "RADIO";
    InputType[InputType["TEXT"] = 3] = "TEXT";
    InputType[InputType["TEXTAREA"] = 4] = "TEXTAREA";
    InputType[InputType["NUMBER"] = 5] = "NUMBER";
    InputType[InputType["EMAIL"] = 6] = "EMAIL";
    InputType[InputType["PASSWORD"] = 7] = "PASSWORD";
    InputType[InputType["DATE"] = 8] = "DATE";
    InputType[InputType["DATETIME"] = 9] = "DATETIME";
    InputType[InputType["CURRENCY"] = 10] = "CURRENCY";
    InputType[InputType["PHONE"] = 11] = "PHONE";
    InputType[InputType["ZIPCODE"] = 12] = "ZIPCODE";
    InputType[InputType["CEP"] = 13] = "CEP";
    InputType[InputType["CPF"] = 14] = "CPF";
    InputType[InputType["CNPJ"] = 15] = "CNPJ";
    InputType[InputType["CPF_OR_CNPJ"] = 16] = "CPF_OR_CNPJ";
    InputType[InputType["RG"] = 17] = "RG";
    InputType[InputType["MASK"] = 18] = "MASK";
    InputType[InputType["CUSTOM"] = 19] = "CUSTOM";
})(InputType || (InputType = {}));
//# sourceMappingURL=form.enum.js.map